import { ACPVariant } from 'apps/acp/variants/acp-variant';

const colors = {
  neutral: {
    color50: '#fafafa',
    color100: '#f0f3f3',
    color200: '#d9e1e2',
    color300: '#c3c9ca',
    color400: '#adb1b3',
    color500: '#97999b',
    color600: '#797a7c',
    color700: '#53565a',
    color800: '#333f48',
    color900: '#1a2024'
  },
  default: {
    color50: '#E6EEF1',
    color100: '#CCDDE3',
    color200: '#99BBC7',
    color300: '#669AAC',
    color400: '#337890',
    color500: '#005674',
    color600: '#00455D',
    color700: '#003446',
    color800: '#00263F',
    color900: '#001117'
  },
  accent: {
    color50: '#F4FDFD',
    color100: '#E8FAFB',
    color200: '#D1F5F7',
    color300: '#BAF1F2',
    color400: '#A3ECEE',
    color500: '#8CE7EA',
    color600: '#70B9BB',
    color700: '#548B8C',
    color800: '#385C5E',
    color900: '#1C2E2F'
  },
  positive: {
    color50: '#E3FAF3',
    color100: '#C7F4E6',
    color200: '#8FEACE',
    color300: '#57DFB5',
    color400: '#2EAA91',
    color500: '#05746D',
    color600: '#045D57',
    color700: '#034641',
    color800: '#022E2C',
    color900: '#011716'
  },
  negative: {
    color50: '#f7e0da',
    color100: '#e7c1b5',
    color200: '#e7a290',
    color300: '#df836a',
    color400: '#d76445',
    color500: '#cf4520',
    color600: '#a6371a',
    color700: '#7c2913',
    color800: '#531c0d',
    color900: '#290e06'
  },
  special: {
    color50: '#F6ECF2',
    color100: '#ECD9E4',
    color200: '#D8B3C9',
    color300: '#C58DAE',
    color400: '#B16793',
    color500: '#9E4178',
    color600: '#7E3460',
    color700: '#5F2748',
    color800: '#3F1A30',
    color900: '#200D18'
  }
};

const variant: ACPVariant = {
  id: 'www.netspend.com/all-access',
  productTitle: 'Netspend Debit Account',
  productType: 'consumer_dda',
  accessDomain: {
    subdomain: 'www',
    domain: 'netspend',
    topLevelDomain: 'com'
  },
  colors,
  logoOverrides: [
    {
      file: 'logo.meta.svg',
      bank: 'meta'
    },
    {
      file: 'logo.svg'
    }
  ],
  themeConfiguration: {
    acpActivationAppBar: {
      defaultBackgroundColor: '#fff'
    },
    tileIcon: {
      positive: {
        color50: colors.special.color50,
        color100: colors.special.color100,
        color200: colors.special.color200,
        color300: colors.special.color300,
        color500: colors.special.color500
      }
    },
    featureIcon: {
      positive: colors.special.color500
    }
  },
  legacyAcpTheme: 'netspend-all-access',
  legacyAcpBrandName: 'netspend',
  legacyLegosTheme: 'netspend',
  status_bar_background_color: '#FFFFFF',
  status_bar_foreground_color: 'dark',
  contactInfo: {
    name: 'Ouro Global, Inc.',
    contact_address_line1: 'PO Box 2136',
    contact_address_line2: 'Austin, TX 78768-2136',
    contact_address_line3: '',
    customer_support_email: 'customerservice@netspend.com',
    fax_formatted: '(512) 857-0263',
    phone_formatted: '(800) 269-4146',
    phone: '8002694146',
    phone_international: '737-220-8956',
    balance_check_phone: '8666476929',
    balance_check_phone_formatted: '1-866-647-6929',
    pre_funded_checks_phone: '18778147683',
    pre_funded_checks_phone_formatted: '1-877-814-7683'
  },
  configuration: {
    apiKeys: {
      appsFlyerDevKey: '5Us7NeWk6WVjGLsAnKioSk',
      appsFlyerBannerKey: '12b98c4b-1b8a-4c16-bcfb-b474b4c6bd54',
      'google-tag-manager-container-id': 'GTM-NQXKPD',
      'google-tag-manager-container-id-mobile': 'GTM-MWBTT5M',
      paypalFraudNetPayerIdProd: '',
      paypalFraudNetPayerIdTest: ''
    },
    featureToggles: {
      activationSetExternalId: false,
      appsFlyerEnabled: false,
      combinedTransactionsMasterAndSub: false,
      'embedded-activation': true,
      embeddedPayNearMe: false,
      hasNotificationCenter: false,
      mobilePBREnabled: true,
      preOnboardingEnabled: false,
      showAccountDisplayNickname: false,
      showAcquisitionLink: false,
      showATMFriendlyCards: true,
      showDisplayNameForSubAccount: false,
      showEmailInformationButton: true,
      showFeePlanPage: false,
      showHowToEarnRewardPointLink: true,
      showRegisterLink: true,
      showScanCardRegistration: true,
      showMarketingSiteLink: true,
      showFreeAtmFinderLink: false,
      showWUTransfers: true,
      showReloadLocationLink: false
    },
    misc: {
      distributor: 'netspend_online',
      productNameAdjective: 'Debit',
      layoutComponentOverride: false,
      layoutAppBarInverted: true,
      loader: 'generic',
      iOSAppId: '407835353',
      payNearMeButtonTextColor: '#FFFFFF',
      payNearMeActionBarBackgroundColor: '#0092BC',
      payNearMeTitleTextColor: '#FFFFFF',
      payNearMeColorAccent: '#84bd00',
      marketingSiteUrl: 'https://www.netspend.com/bank-account',
      marketingSiteLinkText: 'Netspend.com',
      locationSearchMax: '25',
      adaChatbotHandle: 'netspend'
    },
    content: {},
    disclaimers: {},
    sections: [
      'dashboard-gpr',
      'dashboard-lite',
      'dashboard-handoff',
      'layout',
      'manage-gpr',
      'move-money',
      'overdraft',
      'locations',
      'direct-deposit',
      'direct-deposit-mobile-panel',
      'statements',
      'contact-us',
      'restrictions-readonly',
      'feeplan',
      'western-union',
      'disclosure-dictionary',
      'check-deposit',
      'checks',
      'quickbooks-oauth',
      'points',
      'post-handoff-to-activate-register',
      'upgrade',
      'offers',
      'offers-intro',
      'tours',
      'post-install-multi-screen-acquisition-flow',
      'echecks',
      'external-loyalty',
      'secure-inbox',
      'benefit-center',
      'atm-finder',
      'savings',
      'pay-bills',
      'premier-plan',
      'activation',
      'speedy-rewards',
      'savings-transfer',
      'anytime-alerts',
      'anytime-alerts-upgrade',
      'change-username',
      'change-password',
      'mobile-check-load',
      'feedback',
      'rent-track',
      'direct-deposit-form',
      'dynamic-faq',
      'billpay',
      'card',
      'refer-a-friend',
      'close-account',
      'points-learn-more',
      'family-cards',
      'bank-transfers',
      'handoff',
      'debit-card-transfers',
      'card-use-settings',
      'secure-upload',
      'digital-wallet',
      'me-to-me-transfer',
      'money-gram',
      'survey',
      'dda-activation',
      'debit-card-transfers-disbursement',
      'spend-money',
      'fraud-detection',
      'spending-tracker',
      'connected-banks',
      'interstitials',
      'dd-tracker'
    ]
  }
};

export default variant;
